import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DatePickerModule } from 'primeng/datepicker';

interface DatepickerFieldProps extends FormlyFieldProps {
  showTime: boolean;
  timeOnly: boolean;
  placeholderText: string;
  canClear: boolean;
}

@Component({
  selector: 'app-datepicker-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    DatePickerModule,
    NgIf,
    TranslatePipe,
  ],
  templateUrl: './datepicker-field.component.html',
  styleUrl: './datepicker-field.component.scss',
})
export class DatepickerFieldComponent
  extends FieldType<FieldTypeConfig<DatepickerFieldProps>>
  implements OnInit
{
  override defaultOptions = {
    props: {
      showTime: false,
      timeOnly: false,
      placeholderText: 'COMMON.CHOOSE',
      canClear: false,
    },
  };

  public ngOnInit(): void {
    if (this.formControl.value) {
      this.formControl.setValue(new Date(this.formControl.value));
    }
  }
}
